module.exports = __webpack_public_path__ + "static/media/triangle.850d947a.svg";